import {Controller} from '@hotwired/stimulus'

function csrfToken() {
  const meta = document.querySelector('meta[name="csrf-token"]')
  return meta ? meta.getAttribute('content') : ''
}

export default class extends Controller {
  static values = {url: String, countUrl: String}
  static targets = ['launchButton']

  launch() {
    this.launchButtonTarget.disabled = true

    fetch(this.countUrlValue, {
      headers: {'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json'},
      credentials: 'same-origin',
    })
      .then((r) => r.json())
      .then((data) => {
        /* eslint no-alert: 0 */
        if (data.confirmation && !window.confirm(data.confirmation)) {
          this.launchButtonTarget.disabled = false
          return
        }

        this.performDisable()
      })
      .catch(() => {
        this.launchButtonTarget.disabled = false
      })
  }

  performDisable() {
    fetch(this.urlValue, {
      method: 'PUT',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': csrfToken(),
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      credentials: 'same-origin',
    }).then((response) => {
      if (response.ok)
        window.location.reload()
      else
        this.launchButtonTarget.disabled = false
    }).catch(() => {
      this.launchButtonTarget.disabled = false
    })
  }
}
